import { render, staticRenderFns } from "./signDocumentsPage.vue?vue&type=template&id=4717e26e&scoped=true&"
import script from "./signDocumentsPage.vue?vue&type=script&lang=ts&"
export * from "./signDocumentsPage.vue?vue&type=script&lang=ts&"
import style0 from "./signDocumentsPage.vue?vue&type=style&index=0&id=4717e26e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4717e26e",
  null
  
)

export default component.exports